import axios from "axios";
import GenerateURN from "../utils/generateUrn";
import CommonHeader from "../utils/commonHeader";

const getBaseURL = (pageType) => {
  if (pageType === "SESSION_INIT") {
    return process.env.REACT_APP_INIT_API;
  }
  return process.env.REACT_APP_KAWACH_GATEWAY_URL;
};

// Same headers as encryptionInterceptor, but the request body is sent as-is —
// for endpoints that take plain JSON.
const createInterceptorNoEncryption = (pageType = null) => {
  const instance = axios.create({
    baseURL: getBaseURL(pageType),
    headers: { "Content-Type": "application/json" },
  });

  instance.interceptors.request.use(async (config) => {
    config.headers["urn"] = GenerateURN();
    config.headers["counterId"] = 0;
    config.headers["clientid"] = process.env.REACT_APP_CLIENT_ID;

    const agentId = localStorage.getItem("agentId");
    if (agentId) {
      config.headers["agentId"] = agentId;
    }

    try {
      const bearerData = await CommonHeader(pageType);
      config.headers["bearerData"] = bearerData.bearerData;
    } catch (error) {
      console.error("Error fetching bearerData:", error);
    }

    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  });

  return instance;
};

const defaultInterceptorNoEncryption = createInterceptorNoEncryption();

defaultInterceptorNoEncryption.withType = (type) =>
  createInterceptorNoEncryption(type);

export default defaultInterceptorNoEncryption;
